import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { Field, FixedSingleSelect, Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import { useApi, useWorkspace } from '~/contexts';
import TaskDetails from './TaskDetails';

export default function BulkSetStatus({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Set Status"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={TaskDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ statusId: null }}
        onSubmit={async (values) => {
          return api.www
            .workspaces(workspace.id)
            .projects(projectId)
            .tasks()
            .bulkSetStatus(ids, { statusId: values.statusId })
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          statusId: Yup.string().label('Status').nullable().required(),
        })}>
        {() => (
          <Form>
            <p>
              Set the status of {ids.length} {pluralize('task', ids.length)} to:
            </p>

            <Form.Control>
              <Field.ProjectTaskStatusSelect name="statusId" placeholder="Status" component={FixedSingleSelect} />
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
